import { LoginResponse, User } from "../types/auth";
import { fetchWithAuth } from "./api";

interface UserResponse {
  success: boolean;
  data: User;
  message: string;
}

export const authService = {
  login: async (email: string, password: string): Promise<LoginResponse> => {
    return fetchWithAuth("/login", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    });
  },

  logout: async (): Promise<void> => {
    return fetchWithAuth("/logout", {
      method: "POST",
    });
  },

  getCurrentUser: async (): Promise<User> => {
    try {
      const response = (await fetchWithAuth("/user", {
        method: "GET",
      })) as UserResponse;

      if (!response.success) {
        throw new Error(response.message || "Failed to fetch user data");
      }

      return response.data;
    } catch (error) {
      console.error("Error fetching user:", error);
      throw error;
    }
  },

  // Add other auth-related endpoints here
};
